var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5488: {
		fallback: () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	1047: {
		fallback: () => (__webpack_require__.e(144).then(() => (() => (__webpack_require__(3144))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	2948: {
		fallback: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(7961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@maersk-global/apmt-react-icons",
	},
	4660: {
		fallback: () => (__webpack_require__.e(457).then(() => (() => (__webpack_require__(838))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@maersk-global/apmt-react-layout",
	},
	8786: {
		fallback: () => (__webpack_require__.e(955).then(() => (() => (__webpack_require__(8955))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.30.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",
	},
	2400: {
		fallback: () => (Promise.all([__webpack_require__.e(139), __webpack_require__.e(650)]).then(() => (() => (__webpack_require__(4452))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@maersk-global/apmt-flow-keycloak",
	},
	2816: {
		fallback: () => (__webpack_require__.e(555).then(() => (() => (__webpack_require__(6555))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.29.12",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",
	},
	9308: {
		fallback: () => (Promise.all([__webpack_require__.e(449), __webpack_require__.e(216)]).then(() => (() => (__webpack_require__(3216))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@maersk-global/apmt-dpos-common",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"47": [
		1047
	],
	"390": [
		2400,
		2816,
		9308
	],
	"488": [
		5488
	],
	"905": [
		4660,
		8786
	],
	"948": [
		2948
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}